import {Action} from '@ngrx/store';
import {AdminSettingResponse} from '../models/admin-setting-response';
import {PagingModel} from '../models/paging-model';
import {Setting} from '../models/setting';
import { ErrorModel } from '../models/error-model';

export const LOAD_ALL_SETTINGS = '[Setting] LoadAll';
export const LOAD_ALL_SETTINGS_COMPLETE = '[Setting] LoadAllComplete';
export const SAVE_SETTING = '[Setting] Save';
export const SAVE_SETTING_COMPLETE = '[Setting] SaveComplete';
export const GET_SETTING_DETAILS = '[Setting] GetById';
export const GET_SETTING_DETAILS_COMPLETE = '[Setting] GetByIdComplete';

export class LoadAllSettingsAction implements Action {
  readonly type = LOAD_ALL_SETTINGS;

  constructor(public payload: PagingModel) {}
}

export class LoadAllSettingsCompleteAction implements Action {
  readonly type = LOAD_ALL_SETTINGS_COMPLETE;

  constructor( public payload: AdminSettingResponse) {}
}

export class SaveSettingAction implements Action {
  readonly type = SAVE_SETTING;

  constructor(public payload: Setting) {}
}

export class SaveSettingCompleteAction implements Action {
  readonly type = SAVE_SETTING_COMPLETE;

  constructor(public payload: Setting) {}
}

export class GetSettingDetailsAction implements Action {
  readonly type = GET_SETTING_DETAILS;

  constructor(public payload: number) {}
}

export class GetSettingDetailsCompleteAction implements Action {
  readonly type = GET_SETTING_DETAILS_COMPLETE;

  constructor(public payload: Setting) {}
}

export type Actions = LoadAllSettingsAction |
  LoadAllSettingsCompleteAction |
  SaveSettingAction |
  SaveSettingCompleteAction |
  GetSettingDetailsAction |
  GetSettingDetailsCompleteAction;



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/actions/setting.ts